import jApi from './jApi';

export default {
  getListCompanyDrive(params) {
    const api = jApi.generateApi();
    return api.post('/company-drive/explore', params)
      .then(res => res.data);
  },
};



// WEBPACK FOOTER //
// ./src/services/jApiCompanyDrive.js